module.exports = __webpack_public_path__ + "img/error_bg.7e3bd3aa.jpg";